/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Status_DisabledInputs */

const id_reseller_pricing_status_disabled = /** @type {(inputs: Reseller_Pricing_Status_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nonaktif`)
};

const en_reseller_pricing_status_disabled = /** @type {(inputs: Reseller_Pricing_Status_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off sale`)
};

/**
* | output |
* | --- |
* | "Off sale" |
*
* @param {Reseller_Pricing_Status_DisabledInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_status_disabled = /** @type {((inputs?: Reseller_Pricing_Status_DisabledInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Status_DisabledInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_status_disabled(inputs)
	return id_reseller_pricing_status_disabled(inputs)
});